module.exports = __webpack_public_path__ + "static/media/DaWoman.e8947759.png";